import { useDeleteOkProgramMutation, type OkProgram } from 'prove-common'
import { OkProgramForm } from '../../components/reference-data/ReferenceEntityForms'
import { ReferenceTable } from '../reference-table/ReferenceTable'

export const OkProgramTable = ({ okPrograms }: { okPrograms: OkProgram[] }) => {
  const remove = useDeleteOkProgramMutation()
  return (
    <ReferenceTable
      rows={okPrograms}
      title='OK-program'
      emptyTitle='Ingen OK-programmer'
      columns={[
        { key: 'number', label: 'Nummer', value: (row) => row.number },
        { key: 'name', label: 'Navn', value: (row) => row.name },
        { key: 'id', label: 'ID', value: (row) => row.id, copy: true }
      ]}
      name={(row) => `${row.number} ${row.name}`}
      editForm={(row, close) => <OkProgramForm program={row} onClose={close} />}
      onDelete={(id) => remove.mutateAsync(id)}
    />
  )
}
